export enum TimesheetStatusEnums {
  OPEN,
  COMPLETED,
  APPROVED,
  REJECTED,
}
